export default __webpack_public_path__ + "static/media/about-profile.8b42d470.jpg";